import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";

import "swiper/css";

export default function Banner() {
  const [tokenSold, setTokenSold] = useState(0);
  const [presaleInfiBalance, setPresaleInfiBalance] = useState(0);
  const now = 60;

  return (
    <>
      <section className="hero-banner">
        <Container className="pt-5">
          <Row className="">
            <Col lg={6} className="mb-4">
              <div className="banner_content position-relative start-0 end-0">
                <h1 className="mb-3">
                  Welcome to <span className="text-primary">INFI</span> HUB
                  <span className="fw-normal ms-2">
                    - Your Gateway to the Future of Decentralised Finance
                  </span>
                </h1>
                <p className="fs-5">
                  INFI HUB introduces a comprehensive ecosystem built around the
                  INFI coin, governed by the ©SbSe Protocol. It is designed to
                  provide a seamless and intuitive experience, making it easy
                  for users to navigate and engage with its innovative features.
                </p>
              </div>
              <div
                className="btn-bg btn-bg2
              
              mt-5 position-relative"
              >
                <div className="position-relative z-1">
                  <div className="mb-2">
                    <Button
                      variant="custombtn"
                      className="text-uppercase text-black fw-bold px-3 rounded-5 btn-register w-100 investmentbtn"
                      as="a"
                     // href="https://www.invertedinvestment.com/"
                      target="_blank"
                    >
                      Powered by the SbSe Protocol&nbsp;&nbsp;
                      {/* <svg
                        style={{ marginTop: "-3px" }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="16"
                        viewBox="0 0 24 19"
                        fill="none"
                      >
                        <path
                          d="M15.9223 1.39307L22.803 9.52486M22.803 9.52486L15.9223 17.6566M22.803 9.52486L1.45706 9.52485"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg> */}
                    </Button>
                    {/* <Button
                        variant="primary"
                        className="text-uppercase  text-black fw-bold px-4 rounded-5 btn-register"
                      >
                        Buy Token Now
                      </Button> */}
                  </div>
                  <div className="text-center">
                    <p className="text-white small powered">
                      Powered by the fully decentralized SbSe Protocol pioneering technology.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={1}></Col>
            <Col lg={5} className={`cardStyle tokensalebox mb-4`}>
              <div className="threecoin z-2  mb-5 overflow-hidden">
                {/* <img src="images/threecoin.png" alt="" width={`100%`} /> */}
                <img
                  src="images/coin1.png"
                  alt=""
                  className="coin1 position-absolute"
                />
                <img
                  src="images/coin2.png"
                  alt=""
                  className="coin2 position-absolute"
                />
                <img
                  src="images/coin3.png"
                  alt=""
                  className="coin3 position-absolute"
                />
              </div>
              {/* <div>
                <Card className="rounded-3">
                  <Card.Body>
                    <h4 className="fw-normal mb-3">
                      <span className="fw-bold text-primary3">INFI ICO</span> –
                      INFI Token Access
                      Event – Join the Next Phase of Decentralized
                      Utility
                    </h4>
                    <p className="small">
                      The INFI Token Access Event (previously
                      referred to as an ICO) offers early participants the
                      ability to acquire utility tokens that power the
                      SbSe Protocol — a decentralized blockchain
                      ecosystem designed for transparent,
                      permissionless participation.
                    </p>
                    <div
                      className="text-center"
                      style={{ marginBottom: "-34px" }}
                    >
                      <Button
                        variant="custombtn"
                        className="text-uppercase text-black fw-bold px-3 rounded-5 btn-register small position-relative z-1"
                        as="a"
                        href="https://infimultichain.com/ico/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Participate Now &nbsp;&nbsp;
                        <svg
                          style={{ marginTop: "-3px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="11"
                          viewBox="0 0 24 19"
                          fill="none"
                        >
                          <path
                            d="M15.9223 1.39307L22.803 9.52486M22.803 9.52486L15.9223 17.6566M22.803 9.52486L1.45706 9.52485"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </div> */}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
